var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("table", [
    _c("caption", [_vm._v(" " + _vm._s(_vm.T.wordsBestSolvers) + " ")]),
    _c("thead", [
      _c("tr", [
        _c("th", [_vm._v(_vm._s(_vm.T.contestParticipant))]),
        _c("th", [_vm._v(_vm._s(_vm.T.wordsLanguage))]),
        _c("th", [_vm._v(_vm._s(_vm.T.wordsMemory))]),
        _c("th", [_vm._v(_vm._s(_vm.T.wordsRuntime))]),
        _c("th", [_vm._v(_vm._s(_vm.T.wordsTime))])
      ])
    ]),
    _c(
      "tbody",
      _vm._l(_vm.solvers, function(solver) {
        return _c("tr", { key: solver.username }, [
          _c(
            "td",
            { attrs: { "data-submission-user": "" } },
            [
              _c("omegaup-username", {
                attrs: {
                  classname: solver.classname,
                  username: solver.username,
                  linkify: true
                }
              })
            ],
            1
          ),
          _c("td", { attrs: { "data-submission-language": "" } }, [
            _vm._v(_vm._s(solver.language))
          ]),
          _c("td", { attrs: { "data-submission-memory": "" } }, [
            _vm._v(
              " " + _vm._s((solver.memory / (1024 * 1024)).toFixed(2)) + " "
            )
          ]),
          _c("td", { attrs: { "data-submission-runtime": "" } }, [
            _vm._v(" " + _vm._s((solver.runtime / 1000.0).toFixed(2)) + " ")
          ]),
          _c("td", { attrs: { "data-submission-time": "" } }, [
            _vm._v(_vm._s(_vm.time.formatTimestamp(solver.time)))
          ])
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }